import { toSentenceCase } from 'common/utils/utilFunctions';

import PromptBuilderLayout from 'features/Settings/PromptBuilder/PromptBuilderLayout';

import DataRefresh from '../DataRefresh/DataRefresh';
import JobScheduler from '../JobScheduler/JobScheduler';
import Notification from '../Notifications/Notifications';
import OverView from '../OverView/OverView';
import Permission from '../Permission/Permission';
import ResetLayout from '../Reset/ResetLayout';
import Security from '../Security/Security';
import System from '../System/System';
import UserManagementList from '../UserManagement/UserManagementList';
import Workflow from '../Workflow/Workflow';

interface ITabsProps {
	id: number;
	label: string;
	isEnabled?: boolean;
	children: React.JSX.Element;
	value: string;
}

export function getTabs(features: Record<string, any>): ITabsProps[] {
	const {
		isAdminOverviewEnabled,
		isAdminUserManagementEnabled,
		isAdminPermissionsEnabled,
		isAdminQueueWorkflowEnabled,
		isAdminSystemEnabled,
		isAdminNotificationsEnabled,
		isAdminSecurityEnabled,
		isAdminJobSchedulerEnabled,
		isAdminEscalationEnabled,
		isAdminChecklistEnabled,
		isAdminPromptBuilderEnabled,
		isAdminResetEnabled,
	} = features;

	const allTabs = [
		{
			id: 1,
			value: '1',
			label: 'Overview',
			isEnabled: isAdminOverviewEnabled,
			children: <OverView />,
		},
		{
			id: 2,
			value: '2',
			label: toSentenceCase('User Management'),
			isEnabled: isAdminUserManagementEnabled,
			children: <UserManagementList />,
		},
		{
			id: 3,
			value: '3',
			label: 'Permissions',
			isEnabled: isAdminPermissionsEnabled,
			children: <Permission />,
		},
		{
			id: 4,
			value: '4',
			label: toSentenceCase('Queue/Workflow'),
			isEnabled: isAdminQueueWorkflowEnabled,
			children: <Workflow />,
		},
		{
			id: 5,
			value: '5',
			label: toSentenceCase('Global Prompt Library'),
			isEnabled: isAdminPromptBuilderEnabled,
			children: <PromptBuilderLayout />,
		},
		{
			id: 6,
			value: '6',
			label: 'System',
			isEnabled: isAdminSystemEnabled,
			children: <System />,
		},

		{
			id: 7,
			value: '7',
			label: 'Notifications',
			isEnabled: isAdminNotificationsEnabled,
			children: <Notification />,
		},
		{
			id: 8,
			value: '8',
			label: 'Security',
			isEnabled: isAdminSecurityEnabled,
			children: <Security />,
		},
		{
			id: 9,
			value: '9',
			label: toSentenceCase('Job Scheduler'),
			isEnabled: isAdminJobSchedulerEnabled,
			children: <JobScheduler />,
		},
		{
			id: 10,
			value: '10',
			label: 'Escalation',
			isEnabled: isAdminEscalationEnabled,
			children: <DataRefresh />,
		},
		{
			id: 11,
			value: '11',
			label: 'Checklist',
			isEnabled: isAdminChecklistEnabled,
			children: <DataRefresh />,
		},
		{
			id: 12,
			value: '12',
			label: 'Reset',
			isEnabled: isAdminResetEnabled,
			children: <ResetLayout />,
		},
	];

	return allTabs.filter((t) => t.isEnabled);
}
